import { CloudEntry } from "./CloudEntry.js";

/**
 * Sortes entries alphabetically with directories first.
 */
export const getSortedEntries = (entries: CloudEntry[]) => {
  return entries.toSorted((a, b) => {
    return a.type === b.type ? compareByPath(a, b) : a.type < b.type ? -1 : 1;
  });
};

const compareByPath = (a: CloudEntry, b: CloudEntry) => {
  const path1 = a.name.toLowerCase();
  const path2 = b.name.toLowerCase();

  return path1 === path2 ? 0 : path1 < path2 ? -1 : 1;
};
